import {
  AccountData,
  OrderPageData,
  OrderPageStatus,
  OrderPageTypes,
  PassOrderPageData,
  VoucherSoldTypes,
} from '../api';

// any is here as authstate is not yet properly typed
export const getOrderPage = (account: AccountData | any, orderPageId: string) => {
  if (!account || !orderPageId) {
    return undefined;
  }
  return account.experiences[0].order_pages.find((o: OrderPageData) => o.id === orderPageId);
};

export const isRescheduleEnabledForOrderPage = (account: AccountData | undefined, orderPageId: string) =>
  !!getOrderPage(account, orderPageId)?.effective_reschedule_policy?.enabled;

export const getOrderPages = (account: AccountData | any, withArchived?: boolean): OrderPageData[] => {
  if (!account) {
    return [];
  }
  if (withArchived) {
    return account.experiences[0].order_pages;
  }
  return account.experiences[0].order_pages.filter((x: OrderPageData) => x.status !== OrderPageStatus.ARCHIVED);
};

export const accountSellsGiftCards = (account: AccountData | undefined): boolean =>
  getOrderPages(account).some(
    (orderPage) =>
      orderPage.effective_vouchers_config?.sold_types === VoucherSoldTypes.MONETARY ||
      orderPage.effective_vouchers_config?.sold_types === VoucherSoldTypes.BOTH,
  );

export const getGiftCardPageLink = (accountId: string) =>
  `${import.meta.env.VITE_REACT_APP_APP_DOMAIN}/giftcard/${accountId}`;

export const accountHasEventOrderPages = (account: AccountData | any) => {
  return getOrderPages(account)?.find((x: OrderPageData) => x.order_page_type === OrderPageTypes.EVENT) !== undefined;
};

export const accountHasPrivateOrderPages = (account: AccountData | any) => {
  return getOrderPages(account)?.find((x: OrderPageData) => x.order_page_type === OrderPageTypes.PRIVATE) !== undefined;
};

export const accountHasCourseOrderPages = (account: AccountData | any) => {
  return getOrderPages(account)?.find((x: OrderPageData) => x.order_page_type === OrderPageTypes.COURSE) !== undefined;
};

export const getPassOrderPages = (account: AccountData | any, withArchived?: boolean): PassOrderPageData[] => {
  if (!account?.pass_order_pages) {
    return [];
  }
  if (withArchived) {
    return account.pass_order_pages;
  }
  return account.pass_order_pages.filter((x: PassOrderPageData) => x.status !== OrderPageStatus.ARCHIVED);
};

export const getPassOrderPage = (
  account: AccountData | any,
  passOrderPageId: string,
): PassOrderPageData | undefined => {
  if (!account || !passOrderPageId) {
    return undefined;
  }
  return account.pass_order_pages?.find((p: PassOrderPageData) => p.id === passOrderPageId);
};

export const getPassOrderPagesUsingOrderPage = (
  account: AccountData | any,
  orderPageId: string,
): PassOrderPageData[] => {
  if (!orderPageId) {
    return [];
  }
  return getPassOrderPages(account).filter(
    (passOrderPage: PassOrderPageData) =>
      passOrderPage.redeemable_on?.some((item) => item.order_page_id === orderPageId) ||
      passOrderPage.parallel_activity_order_page_ids?.includes(orderPageId),
  );
};
